import React, { useState, useEffect, useContext } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import toast from 'react-hot-toast'
import queryString from 'query-string'

import TitleBox from './components/TitleBox'
import GeneralInfo from './components/GeneralInfo'
import TitleForm from './components/TitleForm'
import BulkOptions from 'components/BulkOptions'
import RelatedAssets from './components/RelatedAssets'

import { fetch, del } from 'api/artist'
import { artistExportRecording as exportRecordings, getSelectedRecordingsFile as exportSelectedRecordings } from 'api/download'
import { AuthContext } from 'stores/auth'

const ArtistDetailView = () => {
  const { id } = useParams()
  const authStore = useContext(AuthContext)
  const history = useHistory()
  const location = useLocation()
  const query = queryString.parse(location.search)

  const [showTitleEditForm, setShowTitleEditForm] = useState(false)
  const [currNav, setCurrNav] = useState(query.qf || query.page ? 'Related Assets' : 'Details')
  const [toggleExport, setToggleExport] = useState(false)
  const [selectAll, setSelectAll] = useState(0)
  const [selected, setSelected] = useState({})

  const [record, setRecord] = useState()
  const [showTable, setShowTable] = useState(false)

  let initialValues = {}
  if (record) {
    initialValues = Object.assign({}, record)
  }

  useEffect(() => {
    if (record === undefined || record.pk !== id) {
      fetch(id).then((res) => {
        toast.loading('Fetching artist..')
        if (res.status === 200) {
          setRecord(res.data)
          toast.dismiss()
        } else {
          toast.error('Unable to load artist')
        }
      }).catch(err=>{
        console.log(err.response)
        toast.error('Unable to load artist')
      })
    }
  }, [])

  const getExport = (typer) => {
    var data = { pk: id, typer: typer }
    exportRecordings(data).then(res => {
      if (res.status === 200) {
        history.push('/download/my-exports/?date=' + res.data.date + '/')
      }
    })
  }

  const _toggleTitleEdit = (form) => {
    if (form === 'artistTitle') {
      setShowTitleEditForm(!showTitleEditForm)
    }
  }

  const deleteArtist = () => {
    del(id).then(res => {
      if (res.status === 204) {
        history.push('/dashboard/')
        toast.success('Successfully deleted artist!')
      } else {
        toast.error('Unable to delete artist')
      }
    }).catch(err=>{
      console.log(err.response)
      toast.error('Unable to delete artist')
    })
  }

  const setExport = () => {
    if (!toggleExport) {
      setToggleExport(true)
    } else {
      setToggleExport(false)
    }
  }

  if (record === undefined) {
    return null
  }

  let scope = authStore.scope
  let email = authStore.user.email

  const bulkItems = [
    {
      name: 'Exploration Format',
      label: 'Export',
      action: getExport,
      params: 'exprecordings'
    },
    {
      name: 'SoundExchange Format', 
      submenu: [
        {
          name: 'Exploration',
          action: getExport,
          params: 'seexploration'
        },
        {
          name: 'Client',
          action: getExport,
          params: 'seclient'
        }
      ]
    },
    {
      name: 'DDEX Format', 
      submenu: [
        {
          name: 'YouTube',
          action: getExport,
          params: 'ytddex'
        },
        {
          name: 'Soundcloud',
          action: getExport,
          params: 'scddex'
        }
      ]
    }
  ]

  const navigation = [
    { name: 'Details', href: '#nav-details'},
    { name: 'Related Assets', href: '#nav-recordings' }
  ]

  return (
    <>
      <div className='flex flex-wrap flex-1 min-h-full'>
        <div className='p-6 flex-1'>
          {showTitleEditForm
            ? <TitleForm
              initialValues={initialValues}
              id={id}
              showTitleEditForm={showTitleEditForm}
              setShowTitleEditForm={setShowTitleEditForm}
              setRecord={setRecord}
            />
          : <TitleBox
              _toggleTitleEdit={_toggleTitleEdit}
              record={record}
              onDelete={deleteArtist}
              email={email}
              scope={scope}
            />
          }

          <nav className="hidden lg:py-2 lg:flex lg:space-x-8 bg-white shadow sm:rounded-md" aria-label="Global">
            <div className="ml-3">
              {navigation.map((item) => (
                <button
                  type='button'
                  key={item.name}
                  className={item.name === currNav 
                    ? 'bg-white py-2 px-4 mr-2 border-red-600 text-gray-900 inline-flex items-center border-b-2 text-sm font-medium'
                    : 'bg-white py-2 px-4 mr-2 border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                  }
                  onClick={() => setCurrNav(item.name)}
                  aria-current={item.name === currNav ? 'page' : undefined}
                >
                  {item.name}
                </button>
              ))}
            </div>
          </nav>
          <hr />
          <div className='bg-white shadow overflow-hidden sm:rounded-md tab-content' id='nav-tabContent'>
            {currNav === 'Details' &&
              (<div className='tab-pane tab-pad fade'
                id='nav-details' role='tabpanel' aria-labelledby='nav-details-tab'>
                <GeneralInfo
                  record={record}
                  scope={scope}
                />
              </div>)       
            }
            {currNav === 'Related Assets' &&
              (<div className='tab-pane tab-pad fade' id='nav-assets' role='tabpanel' aria-labelledby='nav-assets-tab'>
                <RelatedAssets
                  id={id}
                  songCount={record.related_recordings}
                  setExport={setExport}
                  showTable={showTable}
                  setShowTable={setShowTable}
                  selected={selected}
                  setSelected={setSelected}
                  selectAll={selectAll}
                  setSelectAll={setSelectAll}
                />
              </div>)
            }
          </div>
        </div>
        { toggleExport &&
          (<div className="flex-grow-0 flex-shrink-0">
            <BulkOptions items={bulkItems} onClose={setExport}  />
          </div>)
        }
      </div>
    </>
  )
}

export default ArtistDetailView
